module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/product-item-line-boxoffice/product-item-line-boxoffice.component.scss
// module id = ./src/app/modules/boxoffice-module/components/product-item-line-boxoffice/product-item-line-boxoffice.component.scss
// module chunks = 9